module.exports = __webpack_public_path__ + "media/images/admin/icons/phone-missed-ca680c473b3d6fd82b279b8507d318e6.svg";